import React from 'react';
import { useNavigate } from 'react-router-dom';
import './statusPages.css';

import openBook from '../assets/imgs/openBook.png';

const ComingSoon = () => {
  const navigate = useNavigate();

  return (
    <main className="statusPage">
      <button className="statusClose" onClick={() => navigate(-1)}>
        ×
      </button>

      <img src={openBook} alt="Open book" />

      <h1>Coming Soon</h1>
      <p>
        This day’s events are currently unavailable, but it will soon become
        part of the CIBF 2027 journey.
      </p>

      <button className="statusBtn" onClick={() => navigate('/Events')}>
        Go back
      </button>
    </main>
  );
};

export default ComingSoon;